import React, { useEffect, useState } from "react";
import BaseCampanaBonoTutoria from "./BaseCampanaBonoTutoria";
import { usePropsSelect } from "../../../../hooks/useProps/usePropsSelect";
import { usePropsInputs } from "../../../../hooks/useProps/usePropsInput";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { editCampanaBeneficiosAPI, editCampanaBonoTutoriaAPI, getCampanaBonoTutoriaToEditAPI, getCampanaToEditAPI, getSolicitudesByCampanaBonoTutoriaAPI } from "../../../../consumers/backendApisUrls";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import useDidMountEffect from "../../../../hooks/useDidMountEffect/useDidMountEffect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { Alert } from "react-bootstrap/Alert";
import CustomCardAlert from "../../../../components/alerts/CustomCardAlert";
import { toast } from "react-toastify";
//import CustomAlert from "../../com";

const EditCampanaBonoTutoria = ({ toggleModal, refreshPage, IdCampanaBonoTutoria }) => {
    const SECTION_NAME = "EditarCampanaBonoTutoria";

    const [formValues, setFormValues] = useState({});
    const [solicitudes, setSoliciudes] = useState({});
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [filas, setFilas] = useState([]);
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [selectProps] = usePropsSelect(
        allDropdowns,
        formValues,
        setFormValues,
        SECTION_NAME
    );
    const [isLoading, setIsLoading] = useState(true);
    const [isUploadingLineamientos, setIsUploadingLineamientos] = useState(false);
    const [isUploadingExcel, setIsUploadingExcel] = useState(false);
    const [submitForm] = useSubmitForm();
    const [executeGet] = useManageGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({ CurrentPage: 1 });
    const [registrosDuplicados, setRegistrosDuplicados] = useState([]);
    const [registrosErrados, setRegistrosErrados] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const KEYS = {
        IdCampanaBonoTutoria: "IdCampanaBonoTutoria",
        NombreCampana: "NombreCampana",
        FechaInicioCampana: "FechaInicioCampana",
        FechaFinCampana: "FechaFinCampana",
        FechaInicioTutoria: "FechaInicioTutoria",
        FechaFinTutoria: "FechaFinTutoria",
        LineamientoFile: "LineamientoFile",
        IdEmpleado: "IdEmpleado",
        FechaTutorInicio: "FechaTutorInicio",
        FechaTutorFin: "FechaTutorFin",
        EstadoRegistro: "EstadoRegistro",
        MontoProporcional: "MontoProporcional",
        CargaExcel: "CargaExcel"
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const api = editCampanaBonoTutoriaAPI();
        const payload = getPayload();
        try {
            await submitForm(
                Object.values(KEYS),
                api,
                payload,
                SECTION_NAME,
                res => successSubmit(res.data)
            );
        } catch (error) {
            console.log("hubo un error")
            toast.success(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getPayload = () => {
        const lineamientoFile = {
            SourceId: 0,
            FileId: 123,
            Path: "temp/lineamientos.pdf",
            OriginalFileName: "lineamientos_original.pdf",
            FileName: "lineamientos.pdf",
            FileExtension: ".pdf",
            UrlS3: "https://s3.amazon.com/bucket/temp/lineamientos.pdf"
        };

        // Simulación de archivo Excel para carga masiva
        const excelFile = {
            SourceId: 0,
            FileId: 124,
            Path: "temp/carga_solicitudes.xlsx",
            OriginalFileName: "carga_solicitudes_original.xlsx",
            FileName: "carga_solicitudes.xlsx",
            FileExtension: ".xlsx",
            UrlS3: "https://s3.amazon.com/bucket/temp/carga_solicitudes.xlsx"
        };
        const filasPayload = filas.map((row) => {
            return {
                IdSolicitudBonoTutoria: row.IdSolicitudBonoTutoria,
                IdEmpleado: row.IdEmpleado,
                IdSede: row.IdSede,
                NombreSede: row.NombreSede,
                FechaTutorInicio: row.FechaTutorInicio,
                FechaTutorFin: row.FechaTutorFin,
                EstadoRegistro: row.EstadoRegistro,
                MontoProporcional: row.MontoProporcional,
                LineamientoFile: lineamientoFile,
                ExcelCarga: excelFile
            };
        });
        return {
            ...formValues,
            // ListaSolicitudBonoTutoria: filasPayload,
        };
    };

    const successSubmit = async (data) => {
        const hasErrors =
            (data.Data.RegistrosDuplicados && data.Data.RegistrosDuplicados.length > 0) ||
            (data.Data.RegistrosErrados && data.Data.RegistrosErrados.length > 0);

        setRegistrosDuplicados(data.Data.RegistrosDuplicados || []);
        setRegistrosErrados(data.Data.RegistrosErrados || []);

        if (hasErrors) {
            setShowAlert(true);
            return;
        }

        toggleModal();
        await refreshPage();
    };
    const handleCloseAlert = async () => {
        setShowAlert(false);
        toggleModal();
        await refreshPage();
    };
    const init = async () => {
        setIsLoading(true)
        await Promise.all([
            executeGet(getCampanaBonoTutoriaToEditAPI(IdCampanaBonoTutoria), successInitCallback),
            getSolicitudesDeCampanaApi()
        ]);
        setIsLoading(false)
    };
    const getSolicitudesDeCampanaApi = async () => {
        await executeManagePost(getSolicitudesByCampanaBonoTutoriaAPI(), getPayloadSolicitudes(), successManageSearchCallback);
    }
    const getPayloadSolicitudes = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdCampanaBonoTutoria: IdCampanaBonoTutoria,
            ...formValues.selectedFilters
        }
    }
    const successManageSearchCallback = ({ data }) => {
        console.log(data)
        const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
        setSoliciudes(lastData => ({ ...lastData, Items, ExtraData }));
        setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
        console.log(Items)
        setFilas(Items)
    }
    const successInitCallback = ({ data }) => {
        setFormValues(prev => ({
            ...prev,
            IdCampanaBonoTutoria: data.IdCampanaBonoTutoria,
            NombreCampana: data.NombreCampana || "",
            FechaInicioCampana: data.FechaInicioCampana || "",
            FechaFinCampana: data.FechaFinCampana || "",
            FechaInicioTutoria: data.FechaInicioTutoria || "",
            FechaFinTutoria: data.FechaFinTutoria || "",
            LineamientoFile: data.LineamientoFile || "", // si hay archivo asociado
        }));
        console.log(data);
    };

    useEffect(() => {
        init();
    }, []);

    useDidMountEffect(() => {
        getSolicitudesDeCampanaApi();
    }, [paginator.CurrentPage, formValues.selectedFilters, IdCampanaBonoTutoria])

    return (
            <BaseCampanaBonoTutoria
                title="Editar nueva campaña"
                toggleModal={toggleModal}
                handleSubmit={handleSubmit}
                puedeEditar={true}
                sectionName={SECTION_NAME}
                filas={filas}
                setFilas={setFilas}
                allDropdowns={allDropdowns}
                setAllDropdowns={setAllDropdowns}
                formValues={formValues}
                setFormValues={setFormValues}
                setSoliciudes={setSoliciudes}
                solicitudes={solicitudes}
                commonProps={commonProps}
                selectProps={selectProps}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                isUploadingExcel={isUploadingExcel}
                setIsUploadingLineamientos={setIsUploadingLineamientos}
                isUploadingLineamientos={isUploadingLineamientos}
                setIsUplsetIsUploadingExcel={setIsUploadingExcel}
                paginator={paginator}
                setPaginator={setPaginator}
                KEYS={KEYS}
                nuevo={false}
                IdCampanaBonoTutoria={IdCampanaBonoTutoria}
                registrosDuplicados={registrosDuplicados}
                registrosErrados={registrosErrados}
                showAlert={showAlert}
                handleCloseAlert={handleCloseAlert}
            />
    )
}
export default EditCampanaBonoTutoria;